/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import { connect } from 'react-redux';
import OrderDetails from './OrderDetails';
import {USER_ROLE} from '../../../constants/APP_CONSTANTS';
import {
    getSchoolDetails,
    getContactDetails,
    getSalesForceDetails,
    getCreatorDetails,
    updateSalesForceOrgUnit,
    saveSelectedSchool,
    searchSchoolByPostalCode
} from "../../../_thunks/order.details.thunk";

import {
    resetSchoolList,
    setOrgUni,
    setClassEnd,
    setClassStart,
    setCourseName,
    setCourseNo,
    setEstimatedEnrollments
} from "../../../_actions/order.details.actions";

import {
    searchUserInfo
} from "../../../_thunks/identity.thunk";

import {
    saveInstructorCourseContact,
} from "../../../_thunks/collection.thunk";


import {saveCourseInfo} from "../../../_thunks/collection.thunk";

function mapStateToProps(state) {
    return {
        activeCollection: state.activeCollection,
        orderDetails : state.orderDetails
    };
}

const mapDispatchToProps = dispatch => {
    return {
        getOrderDetails : (collectionId, creatorId) => {
            dispatch(getSchoolDetails(collectionId));
            dispatch(getContactDetails(collectionId));
            dispatch(getSalesForceDetails());
            dispatch(getCreatorDetails(creatorId));
        },
        onInstitutionModalClose : () => {
            dispatch(resetSchoolList());
        },
        saveSelectedSchool: (collectionId, schoolId, postalCodeSearchString, territoryId, onRequestClose) => {
            return dispatch(saveSelectedSchool(collectionId, schoolId, postalCodeSearchString, territoryId, onRequestClose));
        },
        saveInstructorContact: (collId,params) =>{
            dispatch(saveInstructorCourseContact(collId,params));
        },
        searchInstructorInfo: (searchText) => {
            return dispatch(searchUserInfo(USER_ROLE.Instructor, searchText));
        },
        setOrgUni : orgId => {
            dispatch(setOrgUni(orgId));
        },
        setClassEnd : classEnd => {
            dispatch(setClassEnd(classEnd));
        },
        setClassStart : classStart => {
            dispatch(setClassStart(classStart));
        },
        setCourseNo : courseNo => {
            dispatch(setCourseNo(courseNo));
        },
        setCourseName : courseName => {
            dispatch(setCourseName(courseName));
        },
        setEstimatedEnrollments : estimatedEnrollments => {
            dispatch(setEstimatedEnrollments(estimatedEnrollments));
        },
        setOrgCode : orgCode => {
            dispatch(setOrgUni(orgCode));
        },
        searchSchoolsByPostalCode: (countryCode, postalCode, options ) => {
            return dispatch(searchSchoolByPostalCode(countryCode, postalCode, options));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);


// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/OrderDetailsLink.js